import React from 'react';
import { Progress } from './ui/progress';

interface JobProgressProps {
  jobId: string;
  approach: 'prediction' | 'similarity';
}

export const JobProgress: React.FC<JobProgressProps> = ({ jobId, approach }) => {
  return (
    <div className="space-y-4">
      <div className="text-white">
        <h3 className="font-medium mb-2">Processing Job: {jobId}</h3>
        <p className="text-slate-400 text-sm mb-4">
          Using {approach} approach to rank your companies...
        </p>
      </div>
      
      <div className="space-y-3">
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Analyzing companies</span>
            <span className="text-slate-400">75%</span>
          </div>
          <Progress value={75} className="h-2" />
        </div>
        
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Processing data</span>
            <span className="text-slate-400">45%</span>
          </div>
          <Progress value={45} className="h-2" />
        </div>
        
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Generating results</span>
            <span className="text-slate-400">0%</span>
          </div>
          <Progress value={0} className="h-2" />
        </div>
      </div>
      
      <p className="text-slate-500 text-sm">
        Estimated completion: 2-3 minutes
      </p>
    </div>
  );
}; 